import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react'; 
import UserManagement from './UserManagement';
import KYCUpdates from './KYCUpdates';
import SetCurrencyRate from './SetCurrencyRate';
import BuyTransactions from './BuyTransactions';
import SellTransactions from './SellTransactions';
import AdminSidebar from './AdminSidebar';
import Footer from '../userComponents/Footer';
import '../../styles/styles.css';
import AdminHeader from './AdminHeader';

const CurrexAdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [searchQuery, setSearchQuery] = useState('');
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render

  useEffect(() => {
    document.title = "Currex Admin Dashboard | Bitstek Advisory"; // Set the document title
    const interval = setInterval(() => {
      setRefreshKey((prevKey) => prevKey + 1); // Increment refresh key to trigger re-render
    }, 500000); // Refresh every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagement searchQuery={searchQuery} />;
      case 'kyc':
        return <KYCUpdates searchQuery={searchQuery} />;
      case 'deposit':
        return <SetCurrencyRate searchQuery={searchQuery} />;
      case 'withdraw':
        return <BuyTransactions searchQuery={searchQuery} />;
      case 'Return':
        return <SellTransactions searchQuery={searchQuery} />;
      default:
        return <UserManagement searchQuery={searchQuery} />;
    }
  };

  return (
   
<>
 <AdminHeader page="dashboard" />
<AdminSidebar />  
    <div className="dashboard">
      <h1> Currex Admin Dashboard</h1>
      <div className="tabs">
        <button className={activeTab === 'users' ? 'active' : ''} onClick={() => setActiveTab('users')}>
          User Management
        </button>
        <button className={activeTab === 'kyc' ? 'active' : ''} onClick={() => setActiveTab('kyc')}>
          KYC Updates
        </button>
        <button className={activeTab === 'deposit' ? 'active' : ''} onClick={() => setActiveTab('deposit')}>
          Set Currency Rate
        </button>
        <button className={activeTab === 'withdraw' ? 'active' : ''} onClick={() => setActiveTab('withdraw')}>
          Buy Transactions
        </button>
        <button className={activeTab === 'Return' ? 'active' : ''} onClick={() => setActiveTab('Return')}>
          Sell Transactions
        </button>
      </div>

      {/* Search Bar with Icon */}
      <div className="search-bar">
        <Search className="search-icon" size={20} />
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="content">{renderContent()}</div>
    
    </div>
   
 </>

  );
};

export default CurrexAdminDashboard;
